import OrderListTable from './orderListTable.container';

export default OrderListTable